import { render, staticRenderFns } from "./SelfAlignment.vue?vue&type=template&id=baab8f98&scoped=true&"
import script from "./SelfAlignment.vue?vue&type=script&lang=js&"
export * from "./SelfAlignment.vue?vue&type=script&lang=js&"
import style0 from "./SelfAlignment.vue?vue&type=style&index=0&id=baab8f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baab8f98",
  null
  
)

export default component.exports